import { TOptions } from 'i18next';
import { useTranslation } from 'react-i18next';

export type TranslationValues = Record<string, string | number | boolean | Date | null | undefined>;

export function useTranslations(namespace?: string) {
  const { t } = useTranslation();

  return (key: string, values?: TranslationValues): string => {
    const fullKey = namespace ? `${namespace}.${key}` : key;
    return t(fullKey, values as TOptions) as string;
  };
}
